import './ProductToolbar.css'

export default function ProductToolbar() {
  return (
    <div className="product-toolbar flex flex-wrap items-center gap-3 border-b pb-4 text-sm">
      <p className="mr-auto font-bold">Products 1-24 of 248</p>
      <label className="product-toolbar__field flex h-10 items-center px-3">
        <span className="sr-only">Search products</span>
        <input name="product-search" type="search" placeholder="Search Item Name" className="product-toolbar__search w-[145px] bg-transparent outline-none" />
        <span aria-hidden="true" className="ml-2">⌕</span>
      </label>
      <label className="product-toolbar__field flex h-10 items-center gap-2 px-3">
        Sort by:
        <select name="sort" className="bg-transparent outline-none"><option>Relevance</option><option>Price</option></select>
      </label>
      <label className="product-toolbar__field flex h-10 items-center gap-2 px-3">
        Show:
        <select name="page-size" className="bg-transparent font-bold outline-none"><option>24</option><option>12</option></select>
      </label>
      <button type="button" className="product-toolbar__quote h-10 px-6 font-extrabold text-white">QUOTE LIST (3)</button>
    </div>
  )
}
